import { isEmpty } from 'lodash';

const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export function isValidPhoneNumber(phoneNumber: string): boolean {
  return !isEmpty(phoneNumber) && PHONE_REGEX.test(phoneNumber);
}
